// extracted by mini-css-extract-plugin
module.exports = {"title":"styles__title___2DQiA","content":"styles__content___3NNXC","description":"styles__description___2GELa","actions":"styles__actions___2ZYsU","item":"styles__item___3xoDk"};